import { _label } from '../../../vernacular/AppLanguage';

export const IRCTC_MAINTAINANCE_START_TIME_HOURS = 23;
export const IRCTC_MAINTAINANCE_START_TIME_MINS = 45;
export const IRCTC_MAINTAINANCE_END_TIME_HOURS = 0;
export const IRCTC_MAINTAINANCE_END_TIME_MINS = 15;
export const IRCTC_BOOKING_DATE_LIMIT = 123;

export const journeyClasses = [
    {
      id: 'ALL',
      label: "all",
    },
    {
      id: '2S',
      label: "$2S",
    },
    {
      id: 'SL',
      label: "sl",
    },
    {
      id: '3A',
      label: "$3A",
    },
    {
      id: '2A',
      label: "$2A",
    },
    {
      id: '1A',
      label: "$1A",
    },
    {
      id: 'CC',
      label: "cc",
    },
  ];